module.exports = __webpack_public_path__ + "static/img/WulandariTriPutri.a381799.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/WulandariTriPutri.png
// module id = nu64
// module chunks = 36